import { JsonMarkup } from 'components/JsonMarkup.jsx';
import { Dashboard } from '../components/Dashboard';
import getCircleLoaderElement from 'functions/getCircleLoaderElement';

$(function() {
	let documentation = $('#documentation');
	if(documentation.length) {
		documentation.on('click', '.endpoint .description .heading, .endpoint .description .example_url', function(e) {
			let endpoint = $(this).closest('.endpoint');
			documentation.find('.endpoint').removeClass('active');
			endpoint.addClass('active');
		});
		documentation.on('click', '.endpoint .close_test', function(e) {
			let endpoint = $(this).closest('.endpoint');
			documentation.find('.endpoint').removeClass('active');
			endpoint.removeClass('active');
		});

		documentation.on('click', '.test', function(e) {
			let button = $(this);
			let endpoint = $(this).closest('.endpoint');
			let url = endpoint.find('.example_url').data('url');
			let exampleBox = endpoint.closest('.domain');
			button.prop('disabled', true);
			let data = {};
			$.each(endpoint.find('.parameter'), function(i, param) {
				param = $(param);
				let input = param.find(':input');
				let value = $.trim(input.val());
				if(input.is('select') && input.find(':selected').data('is_null')) {
					return;
				}
				if(value !== '') {
					data[input.attr('name')] = input.val();
				}
			});
			let finished = function(response, statusCode = '', statusText = '') {
				let status = endpoint.find('.more_information .status');
				if(statusCode) {
					status.addClass('active');
					status.find('.text').text(statusText);
					status.find('.code').text(statusCode);
				}
				else {
					status.removeClass('active');
				}

				console.log(endpoint);
				console.log(endpoint.find('.example_request_output'));
				console.log(response);
				endpoint.find('.example_request_output').removeClass('loading').html(JsonMarkup(response));
				button.prop('disabled', false);
			};
			let urlUsed = url;
			endpoint.find('.example_request_output').addClass('loading').html(getCircleLoaderElement());
			let method = button.data('method');
			if(!$.isEmptyObject(data) && method === 'GET') {
				urlUsed += '?' + $.param(data);
			}
			endpoint.find('.url_used').text(urlUsed);

			$.ajax({
				type: method,
				url: url,
				data: data,
			}).then((response) => {
				finished(response);
			}, (response) => {
				if(response && response.hasOwnProperty('status')) {
					console.log(response);
					finished(response.responseJSON, response.status, response.statusText);
				}
				else {
					console.log(response);
					finished();
				}
			});
		}).on('click', '.truncated', function(e) {
			$(this).removeClass('truncated').addClass('opened');
		}).on('click', '.opened', function(e) {
			if($(this).find('.opened').length) {
				console.log('found opened ', $(this), $(this).find('.opened'));
				return;
			}
			console.log('toggling', $(this));
			e.stopImmediatePropagation();
			$(this).removeClass('opened').addClass('truncated');
		}).on('click', 'a.heading.name', function(e) {
			e.preventDefault();
		}).on('keypress', '.parameter_edit', function(e) {
			if(e.which == Dashboard.keyCodes.ENTER) {
				e.preventDefault();
				$(this).closest('.endpoint').find('.test:first').click();
			}
		});
	}
});